import { all, call } from 'redux-saga/effects';
import { authSagas } from './userAuthentication/userAuth.sagas';
import { userProfileSagas } from './userDetails/userDetails.sagas';
import { myCourseSagas } from './myCourse/myCourse.sagas';
import { allCourseSagas } from './changeCourse/changeCourse.sagas';
import { profileSagas } from './profile/profile.sagas';
import { mystepSagas } from './mystep/mystep.sagas';
import { notificationSagas } from './notifications/notifications.sagas';
import { testPageSagas } from './testPage/testPage.sagas';
import { allBuyCourseSagas } from './buyCourse/buyCourse.sagas';
import { utilsSagas } from './utilities/utils.sagas';
import { settingsSagas } from './settings/settings.sagas';
import { allSsoSagas } from './sso/sso.sagas';
import { parentDashboardSagas } from './parentDashboard/parentDashboard.sagas';
export default function* rootSaga() {
	yield all([
		call(authSagas),
		call(userProfileSagas),
		call(myCourseSagas),
		call(allCourseSagas),
		call(profileSagas),
		call(mystepSagas),
		call(notificationSagas),
		call(testPageSagas),
		call(allBuyCourseSagas),
		call(utilsSagas),
		call(settingsSagas),
		call(allSsoSagas),
		call(parentDashboardSagas),
	]);
}
